import buildMatchPatternFn from '../../../_lib/buildMatchPatternFn/index';
import buildMatchFn from '../../../_lib/buildMatchFn/index';

const matchOrdinalNumberPattern = /^(\d+)(st|एनडी|rd|th)?/i;
const parseOrdinalNumberPattern = /\d+/i;

const matchEraPatterns = {
  narrow: /^(B|A)/i,
  abbreviated: /^(ई.पू.|AD)/i,
  wide: /^(इसा पुर्व|अन्नो डोमिनी)/i,
};
const parseEraPatterns = {
  any: [/(^B|^ई\.पू\.|^इसा पुर्व)/i, /(^A|^AD|^अन्नो डोमिनी)/i],
};

const matchQuarterPatterns = {
  narrow: /^[1234]/i,
  abbreviated: /^Q[1234]/i,
  wide: /^(पहिलो क्वाटर|दोस्रो क्वाटर|तेस्रो क्वाटर|चौथो क्वाटर)/i,
};
const parseQuarterPatterns = {
  any: [/1/i, /2/i, /3/i, /4/i],
  abbreviated: [/Q1/i, /Q2/i, /Q3/i, /Q4/i],
  wide: [/पहिलो क्वाटर/i, /दोस्रो क्वाटर/i, /तेस्रो क्वाटर/i, /चौथो क्वाटर/i],
};

const matchMonthPatterns = {
  narrow: /^(j|एफ|m|a|s|o|n|d)/i,
  abbreviated:
    /^(जनवरी|फेब्रुअरी|मार्च|अप्रिल|सक्छ|जुन|जुलाई|अगस्त|सेप्टेम्बर|अक्टुबर|नोभेम्बर|डिसेम्बर)/i,
  wide: /^(जनवरी|फेब्रुअरी|मार्च|अप्रिल|सक्छ|जुन|जुलाई|अगस्त|सेप्टेम्बर|अक्टुबर|नोभेम्बर|डिसेम्बर)/i,
};
const parseMonthPatterns = {
  narrow: [
    /^j/i,
    /^एफ/i,
    /^m/i,
    /^a/i,
    /^m/i,
    /^j/i,
    /^j/i,
    /^a/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i,
  ],
  abbreviated: [
    /^जनवरी/i,
    /^फेब्रुअरी/i,
    /^मार्च/i,
    /^अप्रिल/i,
    /^सक्छ/i,
    /^जुन/i,
    /^जुलाई/i,
    /^अगस्त/i,
    /^सेप्टेम्बर/i,
    /^अक्टुबर/i,
    /^नोभेम्बर/i,
    /^डिसेम्बर/i,
  ],
  any: [
    /^जनवरी/i,
    /^फेब्रुअरी/i,
    /^मार्च/i,
    /^अप्रिल/i,
    /^सक्छ/i,
    /^जुन/i,
    /^जुलाई/i,
    /^अगस्त/i,
    /^सेप्टेम्बर/i,
    /^अक्टुबर/i,
    /^नोभेम्बर/i,
    /^डिसेम्बर/i,
  ],
};

const matchDayPatterns = {
  narrow: /^(s|m|t|w|एफ)/i,
  short: /^(सु|मो|Tu|हामी|गु|फ्र|सा)/i,
  abbreviated: /^(सूर्य|सोमबार|मंग|बुधवार|गु|शुक्र|शनि)/i,
  wide: /^(आइतवार|सोमबार|मंगलबार|बुधवार|बिहीबार|शुक्रवार|शनिबार)/i,
};
const parseDayPatterns = {
  narrow: [/^s/i, /^m/i, /^t/i, /^w/i, /^t/i, /^एफ/i, /^s/i],
  short: [/^सु/i, /^मो/i, /^Tu/i, /^हामी/i, /^गु/i, /^फ्र/i, /^सा/i],
  abbreviated: [
    /^सूर्य/i,
    /^सोमबार/i,
    /^मंग/i,
    /^बुधवार/i,
    /^गु/i,
    /^शुक्र/i,
    /^शनि/i,
  ],
  any: [
    /^आइतवार/i,
    /^सोमबार/i,
    /^मंगलबार/i,
    /^बुधवार/i,
    /^बिहीबार/i,
    /^शुक्रवार/i,
    /^शनिबार/i,
  ],
};

const matchDayPeriodPatterns = {
  narrow: /^(a|p|मील|एन|बिहान|दिउँसो|साँझ|रात)/i,
  abbreviated: /^(AM|बेलुकी|मध्यरात|बिहान|दिउँसो|साँझ|रात)/i,
  wide: /^(म|बेलुका|मध्यरात|दिउँसो|बिहान|दिउँसो|साँझ|रात)/i,
};
const parseDayPeriodPatterns = {
  narrow: {
    am: /a/i,
    pm: /p/i,
    midnight: /मील/i,
    noon: /एन/i,
    morning: /बिहान/i,
    afternoon: /दिउँसो/i,
    evening: /साँझ/i,
    night: /रात/i,
  },
  abbreviated: {
    am: /AM/i,
    pm: /बेलुकी/i,
    midnight: /मध्यरात/i,
    noon: /दिउँसो/i,
    morning: /बिहान/i,
    afternoon: /दिउँसो/i,
    evening: /साँझ/i,
    night: /रात/i,
  },
  wide: {
    am: /म/i,
    pm: /बेलुका/i,
    midnight: /मध्यरात/i,
    noon: /दिउँसो/i,
    morning: /बिहान/i,
    afternoon: /दिउँसो/i,
    evening: /साँझ/i,
    night: /रात/i,
  },
};

const match = {
  ordinalNumber: buildMatchPatternFn({
    matchPattern: matchOrdinalNumberPattern,
    parsePattern: parseOrdinalNumberPattern,
    valueCallback: function (value) {
      return parseInt(value, 10);
    },
  }),

  era: buildMatchFn({
    matchPatterns: matchEraPatterns,
    defaultMatchWidth: 'wide',
    parsePatterns: parseEraPatterns,
    defaultParseWidth: 'any',
  }),

  quarter: buildMatchFn({
    matchPatterns: matchQuarterPatterns,
    defaultMatchWidth: 'wide',
    parsePatterns: parseQuarterPatterns,
    defaultParseWidth: 'any',
    valueCallback: function (index) {
      return index + 1;
    },
  }),

  month: buildMatchFn({
    matchPatterns: matchMonthPatterns,
    defaultMatchWidth: 'wide',
    parsePatterns: parseMonthPatterns,
    defaultParseWidth: 'any',
  }),

  day: buildMatchFn({
    matchPatterns: matchDayPatterns,
    defaultMatchWidth: 'wide',
    parsePatterns: parseDayPatterns,
    defaultParseWidth: 'any',
  }),

  dayPeriod: buildMatchFn({
    matchPatterns: matchDayPeriodPatterns,
    defaultMatchWidth: 'wide',
    parsePatterns: parseDayPeriodPatterns,
    defaultParseWidth: 'wide',
  }),
};

export default match;
